<div
  [attr.data-theme]="theme()"
  [ngClass]="theme() === 'dark' ? 'bg-neutral-800' : 'bg-white'"
  [class.overflow-auto]="overflow()"
  class="max-h-[20rem] z-20 flex flex-col py-2 rounded-md shadow-md min-w-max theme-border border"
>
  <ng-content />
</div>
